import styled from "@emotion/styled";

export const Container = styled.div`
  img {
    width: 100vw;
    height: 110vh;
  }
`;
